var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapeGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 6,
    viewBox: "0 0 296 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.676 2.99999L139.448 0.299988L136.15 2.99999L139.448 5.69999L142.676 2.99999Z",
    fill: "#0BAB64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.448 6L135.876 3L139.448 0L143.02 3L139.448 6ZM136.494 3L139.379 5.4L142.264 3L139.448 0.6L136.494 3Z",
    fill: "#0BAB64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.538 2.99999L149.477 1.29999L147.416 2.99999L149.477 4.69999L151.538 2.99999Z",
    fill: "#0BAB64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.477 5L147.072 3L149.477 1L151.881 3L149.477 5ZM147.759 3L149.477 4.4L151.194 3L149.477 1.6L147.759 3Z",
    fill: "#0BAB64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.45 3.00001L293.39 2.10001L291.397 3.00001L293.39 3.90001L295.45 3.00001Z",
    fill: "#0BAB64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.39 4.19999L290.779 2.99999L293.39 1.89999L296 2.99999L293.39 4.19999ZM291.947 2.99999L293.39 3.59999L294.832 2.99999L293.39 2.39999L291.947 2.99999Z",
    fill: "#0BAB64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67108 3.00001L2.61027 2.10001L0.618164 3.00001L2.61027 3.90001L4.67108 3.00001Z",
    fill: "#0BAB64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61035 4.19999L0 2.99999L2.61035 1.89999L5.28939 2.99999L2.61035 4.19999ZM1.16779 2.99999L2.61035 3.59999L4.05291 2.99999L2.61035 2.39999L1.16779 2.99999Z",
    fill: "#0BAB64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.486 2.99999L145.493 1.29999L143.433 2.99999L145.493 4.69999L147.486 2.99999Z",
    fill: "#0BAB64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.493 5L143.089 3L145.493 1L147.897 3L145.493 5ZM143.776 3L145.493 4.4L147.21 3L145.493 1.6L143.776 3Z",
    fill: "#0BAB64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.395 2.99999L133.403 1.29999L131.342 2.99999L133.403 4.69999L135.395 2.99999Z",
    fill: "#0BAB64"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.402 5L130.998 3L133.402 1L135.807 3L133.402 5ZM131.685 3L133.402 4.4L135.12 3L133.402 1.6L131.685 3Z",
    fill: "#0BAB64"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.411 2.99999L129.35 1.29999L127.289 2.99999L129.35 4.69999L131.411 2.99999Z",
    fill: "#0BAB64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.35 5L126.945 3L129.35 1L131.754 3L129.35 5ZM127.632 3L129.35 4.4L131.067 3L129.35 1.6L127.632 3Z",
    fill: "#0BAB64"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.321 2.79999H151.126C151.057 2.79999 150.988 2.89999 150.988 2.99999C150.988 3.09999 151.057 3.19999 151.126 3.19999H293.321C293.39 3.19999 293.458 3.09999 293.458 2.99999C293.527 2.89999 293.458 2.79999 293.321 2.79999Z",
    fill: "#0BAB64"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M293.321 3.5H151.126C150.92 3.5 150.782 3.3 150.782 3C150.782 2.7 150.92 2.5 151.126 2.5H293.321C293.527 2.5 293.665 2.7 293.665 3C293.665 3.3 293.527 3.5 293.321 3.5Z",
    fill: "#0BAB64"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.701 2.79999H2.8161C2.7474 2.79999 2.67871 2.89999 2.67871 2.99999C2.67871 3.09999 2.7474 3.19999 2.8161 3.19999H127.701C127.769 3.19999 127.838 3.09999 127.838 2.99999C127.838 2.89999 127.769 2.79999 127.701 2.79999Z",
    fill: "#0BAB64"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.701 3.5H2.81612C2.61004 3.5 2.47266 3.3 2.47266 3C2.47266 2.7 2.61004 2.5 2.81612 2.5H127.701C127.907 2.5 128.044 2.7 128.044 3C128.044 3.3 127.838 3.5 127.701 3.5Z",
    fill: "#0BAB64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeGreen);
export default __webpack_public_path__ + "static/media/shape-green.5a1ba1f822d0c9623b50e685ebc2eb2f.svg";
export { ForwardRef as ReactComponent };